import { registerPlugin } from '@capacitor/core';

export interface FcmTokenPlugin {
  getToken(): Promise<{ token: string }>;
}

export const FcmToken = registerPlugin<FcmTokenPlugin>('FcmToken', {
  web: {
    async getToken() {
      return { token: '' };
    },
  },
});
